import type { SharePointSync } from '@process-hub/shared';

/** The sentence to add when a change could not reach the published file's SharePoint columns (D-065). */
export function sharePointNote(s: SharePointSync | undefined): string {
  return s === 'failed' ? ' SharePoint was not updated; open the process and use Re-publish PDF to bring its columns in line.' : '';
}
